export default "__VITE_ASSET__DeLbYJOa__"